export const setUserPermissions = user => {
	const uniq = a => [...new Set(a)]
	if (user) {
		let permissionsArray = uniq(user.permissionTokens)
		var elems = document.querySelectorAll('*[data-permission]')

		elems.forEach(element => {
			var currentKey = element.getAttribute('data-permission')
			if (permissionsArray.indexOf(currentKey) === -1 && currentKey != '') {
				element.remove()
			}
		})
	}
}
